/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Loop_Verif_1Inputs */

const en_mk_loop_verif_1 = /** @type {(inputs: Mk_Loop_Verif_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Local — criteria run on your machine through the CLI`)
};

const id_mk_loop_verif_1 = /** @type {(inputs: Mk_Loop_Verif_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lokal — kriteria dijalankan di mesinmu lewat CLI`)
};

/**
* | output |
* | --- |
* | "Local — criteria run on your machine through the CLI" |
*
* @param {Mk_Loop_Verif_1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_loop_verif_1 = /** @type {((inputs?: Mk_Loop_Verif_1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Loop_Verif_1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_loop_verif_1(inputs)
	return en_mk_loop_verif_1(inputs)
});